/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FragmentNames {
  ALTERACAO_BENEFICIARIO = 'alteracao-beneficiario',
  ALTERAR_DATA_ADMISSAO = 'alterar-data-admissao',
  ALTERAR_DATA_VALIDADE = 'alterar-data-validade',
  ALTERAR_LOCALIZACAO = 'alterar-localizacao',
  ALTERAR_MATRICULA = 'alterar-matricula',
  ALTERAR_SENHA = 'alterar-senha',
  ALTERAR_SUBESTIPULANTE = 'alterar-subestipulante',
  ALTERAR_VINCULO = 'alterar-vinculo',
  ANEXO_ITEM_PROD_MAT = 'anexo-item-prod-mat',
  ANEXO_TISS = 'anexo-tiss',
  ASSIGN_AVISO_DE_PRIVACIDADE = 'assign-aviso-de-privacidade',
  ASSIGN_TERM = 'assign-term',
  ASSIGN_TERMO_USO_MODAL = 'assign-termo-uso-modal',
  AUTORIZACAO_DADOS_GUIA = 'autorizacao-dados-guia',
  AUTORIZACAO_GUIA_FORM = 'autorizacao-guia-form',
  BENEFICIARIO_DOSSIE = 'beneficiario-dossie',
  BENEFICIARIO_LOTE = 'beneficiario-lote',
  BENEFICIARY_CHANGE = 'beneficiary-change',
  CARTAO_CONFIRMAR = 'cartao-confirmar',
  CARTAO_CONSULTAR = 'cartao-consultar',
  CARTAO_SOLICITAR = 'cartao-solicitar',
  CONFIRMAR_USUARIO = 'confirmar-usuario',
  CONFIRMAR_USUARIO_FALHA = 'confirmar-usuario-falha',
  CONSULTA_ALTERACAO_CADASTRAL = 'consulta-alteracao-cadastral',
  CONSULTA_ALTERACAO_LOCALIZACAO = 'consulta-alteracao-localizacao',
  CONSULTA_ALTERACAO_MATRICULA = 'consulta-alteracao-matricula',
  CONSULTA_ALTERACAO_PRODUTO = 'consulta-alteracao-produto',
  CONSULTA_ALTERACAO_SUBESTIPULANTE = 'consulta-alteracao-subestipulante',
  CONSULTA_ALTERACAO_VINCULO = 'consulta-alteracao-vinculo',
  CONSULTA_COMPARTILHAMENTO_RISCO = 'consulta-compartilhamento-risco',
  CONSULTA_DATA_ADMISSAO = 'consulta-data-admissao',
  CONSULTA_HISTORICO_ALTERACAO_CADASTRAL = 'consulta-historico-alteracao-cadastral',
  CONSULTA_HISTORICO_INCLUSAO_BENEFICIARIO = 'consulta-historico-inclusao-beneficiario',
  CONSULTA_INCONSISTENCIA_SIB = 'consulta-inconsistencia-sib',
  CONSULTA_MIGRACAO_CONTRATO = 'consulta-migracao-contrato',
  CONSULTA_SEGUNDA_VIA = 'consulta-segunda-via',
  CONSULTA_TRANSFERENCIA_TITULARIDADE = 'consulta-transferencia-titularidade',
  CONTRATO_DOSSIE = 'contrato-dossie',
  CONTRATO_DOSSIE_INFO = 'contrato-dossie-info',
  COOKIES = 'cookies',
  DADOS_GRUPO_CONTRATUAL = 'dados-grupo-contratual',
  DASHBOARD = 'dashboard',
  DINAMICO = 'dinamico',
  DOSSIE_CONTRATO_DOCUMENTOS = 'dossie-contrato-documentos',
  EXCLUSAO_BENEFICIARIO = 'exclusao-beneficiario',
  EXCLUSAO_BENEFICIARIO_CONSULTA = 'exclusao-beneficiario-consulta',
  FATURAS = 'faturas',
  FINALIZAR_REPASSE = 'finalizar-repasse',
  FOLHAS_PAGAMENTO = 'folhas-pagamento',
  HISTORICO_AUTORIZACAO = 'historico-autorizacao',
  HISTORICO_AUTORIZACAO_CONSULTA = 'historico-autorizacao-consulta',
  HISTORICO_REQUISICAO = 'historico-requisicao',
  HISTORICO_REQUISICAO_CONSULTA = 'historico-requisicao-consulta',
  HISTORICO_SOLICITACOES = 'historico-solicitacoes',
  HISTORICO_SOLICITACOES_ATENDIMENTO = 'historico-solicitacoes-atendimento',
  HPMS_REPORTS_MODAL = 'hpms-reports-modal',
  INACTIVITY = 'inactivity',
  INCLUSAO_BENEFICIARIO_CANCELAR = 'inclusao-beneficiario-cancelar',
  INCLUSAO_BENEFICIARIO_CONSULTA = 'inclusao-beneficiario-consulta',
  INCLUSAO_BENEFICIARIO_NOVA_INCLUSAO = 'inclusao-beneficiario-nova-inclusao',
  INCONSISTENCIAS_SIB = 'inconsistencias-sib',
  INCONSISTENCIES_BENEFICIARIO = 'inconsistencies-beneficiario',
  INDICE_REAJUSTE = 'indice-reajuste',
  INDICE_REAJUSTE_DS_DOCUMENTACAO = 'indice-reajuste-ds-documentacao',
  LOCATOR_BENEFICIARIOS = 'locator-beneficiarios',
  LOCATOR_BENEFICIARIOS_EXCLUSAO = 'locator-beneficiarios-exclusao',
  LOCATOR_CBO = 'locator-cbo',
  LOCATOR_LOCAL_ATENDIMENTO = 'locator-local-atendimento',
  LOCATOR_MUNICIPIO = 'locator-municipio',
  LOCATOR_OPERADORA_ANTERIOR = 'locator-operadora-anterior',
  LOCATOR_PROCEDIMENTO = 'locator-procedimento',
  LOGIN = 'login',
  LOTE = 'lote',
  MENSAGEM_DETALHES = 'mensagem-detalhes',
  MENSAGEM_MODAL = 'mensagem-modal',
  MENSAGENS = 'mensagens',
  MENSAGENS_RESUMO = 'mensagens-resumo',
  MENSAGENS_RESUMO_DASHBOARD = 'mensagens-resumo-dashboard',
  MENSALIDADE_NOTA_FISCAL = 'mensalidade-nota-fiscal',
  MENSALIDADE_OBSERVACOES = 'mensalidade-observacoes',
  MENSALIDADES = 'mensalidades',
  MEUS_DADOS = 'meus-dados',
  MIGRACAO_CONTRATO = 'migracao-contrato',
  MOTIVO_REJEICAO = 'motivo-rejeicao',
  MOVIMENTACAO_LOTE = 'movimentacao-lote',
  NEW_PASSWORD = 'new-password',
  OBSERVACAO_ALTERACAO_PRODUTO = 'observacao-alteracao-produto',
  OBSERVACAO_MIGRACAO_CONTRATO = 'observacao-migracao-contrato',
  OBSERVACAO_TRANSF_TITULARIDADE = 'observacao-transf-titularidade',
  PDF_VIEWER = 'pdf-viewer',
  PERSON_DATA = 'person-data',
  PERSON_DATA_CHANGE_REQUESTS = 'person-data-change-requests',
  PERSON_DATA_DETAILS_FORM_EDITABLE = 'person-data-details-form-editable',
  PERSON_DATA_DETAILS_FORM_NON_EDITABLE = 'person-data-details-form-non-editable',
  PESQUISA_UTILIZACAO = 'pesquisa-utilizacao',
  PRIVACIDADE = 'privacidade',
  PRODUCT_CHANGE = 'product-change',
  REDIRECT = 'redirect',
  REINCLUSAO_BENEFICIARIO = 'reinclusao-beneficiario',
  REINCLUSAO_BENEFICIARIO_CONSULTA = 'reinclusao-beneficiario-consulta',
  REINCLUSAO_REJEICAO_FEEDBACK = 'reinclusao-rejeicao-feedback',
  RELATORIOS = 'relatorios',
  REQUISICAO_FORM = 'requisicao-form',
  RESET_PWD = 'reset-pwd',
  ROOT = 'root',
  ROUTES = 'routes',
  SOLICITACAO_EXCLUSAO_FEEDBACK = 'solicitacao-exclusao-feedback',
  SOLICITACOES_PENDENTES = 'solicitacoes-pendentes',
  SOLICITACOES_PENDENTES_DETALHES = 'solicitacoes-pendentes-detalhes',
  SOLICITACOES_PENDENTES_DETALHES_PARECER = 'solicitacoes-pendentes-detalhes-parecer',
  SOLICITACOES_PENDENTES_HISTORICOS = 'solicitacoes-pendentes-historicos',
  SOLICITACOES_PENDENTES_INFORMAR_PARECER = 'solicitacoes-pendentes-informar-parecer',
  SOLICITAR_REPASSE = 'solicitar-repasse',
  STIPULATOR = 'stipulator',
  TABELA_PRECO = 'tabela-preco',
  TRANSFERIR_TITULARIDADE = 'transferir-titularidade',
}
export { FragmentNames };
